import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';

import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { RaceDaysTableService, PlayerTotalPointsItem } from '../service/raceSeasonOverview.service';

@Component({
    selector: 'app-leagueTableOverview-widget',
    standalone: true,
    templateUrl: './leagueTableOverview.component.html',
    styleUrls: ['./leagueTableOverview.component.scss'],
    imports: [
    TableModule,
    RouterModule
],
    providers: [
        RaceDaysTableService,
    ]
})
export class LeagueTableOverviewWidgetComponent implements OnInit {

    @Input() season_id: number = 0;
    @Input() seasonName: string | null = null;

    playerList: PlayerTotalPointsItem[] = [];
    dataLoaded = false;

    constructor(
        private raceDaysTableService: RaceDaysTableService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.dataLoaded = false;
        this.raceDaysTableService.getRaceDaysTable(String(this.season_id)).subscribe((data) => {
            this.playerList = data.sort((a, b) => (b.total_points_v3 ?? 0) - (a.total_points_v3 ?? 0)).slice(0, 10);
            this.dataLoaded = true;
            this.changeDetectorRef.detectChanges();
        });
    }
}
